import React from 'react';
import { connect } from 'react-redux';
import {
  logout,
} from '../../actions';

interface IProps {
  logout(): void;
}

class LogoutContainer extends React.PureComponent<IProps> {
  componentDidMount(): void {
    const { logout } = this.props;
    logout();
  }

  render() {
    return <h1>Done.</h1>
  }
}

export default connect(null, {
  logout,
})(LogoutContainer);
